<template>
    <BreadCrumb PageTitle="Liste des tarifs annuels" />
    <ListeTarifAnnuel/>
  </template>
  
  <script lang="ts">
    import { defineComponent } from "vue";
  
    import BreadCrumb from "../../components/Common/BreadCrumb.vue";
    import ListeTarifAnnuel from "../../components/TarifAnnuel/ListeTarifAnnuel.vue";

  
    export default defineComponent({
      name: "ListeTarifAnnuelPage",
      components: {
        BreadCrumb,
        ListeTarifAnnuel,
      },
    });
  </script>